import { apiStd } from './apiClient.js';

/**
 * Activity log — POST /v1/audit/list.
 * Typical body: `{ page, page_size, order_by: 'created_at', order_direction: 'DESC', search?: { keyword } }`.
 *
 * @param {Record<string, unknown>} body
 * @returns {Promise<{ body?: unknown[], meta?: Record<string, unknown>, statusCode?: number }>}
 */
export const listAuditLog = (body) => apiStd.post('/v1/audit/list', body);
